import React from 'react';

const ContactBanner = () => {
  return (
    <div className="services-banner contact-banner">
      <div className="container">
        <div className="services-banner-wrapper">
          <h1>Contact Us</h1>
          <p>
            Have questions, inquiries, or are eager to explore how Quantome can
            transform your financial journey? We're here to assist you!
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactBanner;
